module.exports = __webpack_public_path__ + "img/Send.8457e745.svg";